import styled, { css } from 'styled-components';
import Colours from '/shared/styled/Colours';

function highlightRowStyle({ $highlightRow }: { $highlightRow?: number | null }) {
  if ($highlightRow) {
    return css`
      tbody tr:nth-child(${$highlightRow}) td {
        color: ${Colours.blackDark1};
        background: ${Colours.greyLight8};
        font-weight: 600;
      }
    `;
  }
}

export default styled.table<{ $highlightRow?: number | null }>`
  border-spacing: 0;
  width: 100%;
  margin-top: 2rem;
  margin-bottom: 1rem;

  tr {
    td, th {
      text-align: left;
      font-size: 0.93333rem;

      &:first-child {
        padding-left: 0;
      }
    }

    td {
      border-bottom: 1px solid ${Colours.greyLight8};
      padding: 1.333333rem 1rem;
      text-align: left;
      color: ${Colours.grey};

      &:not(:first-child) {
        font-size: 0.8rem;
      }

      &:last-child {
        width: 1px;
        white-space: nowrap;
      }
    }

    th {
      border-bottom: 2px solid ${Colours.greenLight2};
      padding: 1rem 1rem;
      font-weight: 700;
      font-size: 0.8rem;
      color: ${Colours.grey};
    }

    &:last-child {
      td {
        border-bottom: 0;
      }
    }
  }
  ${highlightRowStyle}
`;
